import { render, staticRenderFns } from "./MTabs.vue?vue&type=template&id=37010c1c&scoped=true&"
import script from "./MTabs.vue?vue&type=script&lang=js&"
export * from "./MTabs.vue?vue&type=script&lang=js&"
import style0 from "./MTabs.vue?vue&type=style&index=0&id=37010c1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37010c1c",
  null
  
)

export default component.exports